<template>
  <div id="chick-fil-a-tag-info-button">
    <v-btn
      v-if="isChickFilASchool"
      depressed
      color="#E51636"
      v-bind="vBtnProps"
      :class="{
        'chick-fil-a-dashboard-tag-button': service === 'dashboard',
        'chick-fil-a-playlist-tag-button': service === 'playlist-bulb-settings',
      }"
      class="white--text"
      @click.stop="redirectToTagInformation()"
    >
      View tag library
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ChickFilATagButton',
  props: {
    school: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    service: {
      type: String,
      default: 'bulb-settings',
      validator: (service) =>
        [                     // eslint-disable-line
          'batch',
          'bulb-settings',
          'playlist-bulb-settings',
          'dashboard',
          'designer',
          'playlist',
        ].includes(service),
    },
  },
  data() {
    return {
      tagUrl: 'https://lad-design-system.webflow.io/writing-guidelines/metadata#Tagging',
    };
  },
  methods: {
    redirectToTagInformation() {
      window.open(this.tagUrl, '_blank', 'noopener,noreferrer');
    },
  },
  computed: {
    isChickFilASchool() {
      return [2567, 2755, 2756, 2890].includes(this.school.id);
    },
    vBtnProps() {
      if (['dashboard', 'bulb-settings'].includes(this.service)) return { round: true };
      return {
        rounded: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.chick-fil-a-dashboard-tag-button {
  margin-top: -15px;
  margin-right: 37px;
}

.chick-fil-a-playlist-tag-button {
  margin-left: 31px;
}
</style>
